import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover, POPOVER_BODY_SELECTOR, PopoverPosition, PopoverType, Select, SelectState, usePopoverHandlers, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { isOneSizeProduct, isOnlyOneSizeProduct } from '@as-react/common-utils';
import { Box, Label, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { mapSizeSelectOptions } from '../../../util/ProductUtil';
import { SizeDropdown } from '../../size-dropdown/SizeDropdown';
export const MiniPDPSizeSelect = ({ sizes, selectedSku, sizeSelectError, onSizeSelectChange, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const sizeSelectRef = useRef(null);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const { oneSizeProductCode } = useAemConfig();
    const oneSizeProduct = isOneSizeProduct(sizes, oneSizeProductCode);
    const isOneSizeProductInline = isOnlyOneSizeProduct(sizes);
    const { filteredSizes, options: selectOptions } = mapSizeSelectOptions(sizes, true);
    useEffect(() => {
        if (sizeSelectError && !selectedSku) {
            handlePopoverOpen(null, sizeSelectRef.current, false, true);
        }
        else {
            handlePopoverClose();
        }
    }, [sizeSelectError]);
    const handleSelectedItemChange = (option) => {
        onSizeSelectChange(option.value.toString());
    };
    if (isOneSizeProductInline) {
        return (_jsxs(Box, { paddingBlockStart: "4", children: [_jsx(Label, { children: t('pdp.size') }), ' ', _jsx(TextAlpha, { as: "span", variant: "bodyS", testId: "one_size", children: selectOptions[0].label })] }));
    }
    if (oneSizeProduct) {
        return null;
    }
    return (_jsxs(Box, { paddingBlockStart: "4", children: [_jsx(Box, { paddingBlockEnd: "1", children: _jsx(Label, { children: t('pdp.size') }) }), _jsx(SizeDropdown, { id: "mini_pdp_product_tile_size_select", toggleElementRef: sizeSelectRef, appendToBody: true, sizes: filteredSizes, options: selectOptions, selectedSku: selectedSku, handleSelectedItemChange: handleSelectedItemChange, toggleElement: _jsx(Select, { name: "size-select", dataQA: "size-select", options: selectOptions, selectedValue: selectedSku, placeholder: t('pdp.size.choose.default'), defaultOptionValue: selectOptions.length === 1 ? selectOptions[0].value : undefined, state: sizeSelectError ? SelectState.ERROR : undefined, onChange: onSizeSelectChange, fullWidth: true, disabled: true }) }), _jsx(Popover, { type: PopoverType.TOOLTIP, anchorEl: anchorEl, noAnimation: true, onClose: handlePopoverClose, position: PopoverPosition.BOTTOM, stickyWrapper: true, scrollableWrapperEl: document.querySelector(POPOVER_BODY_SELECTOR), children: _jsx(TextAlpha, { variant: "bodyS", as: "span", children: t('pdp.size.choose.default') }) })] }));
};
